/* FemiEko Club: Picături Love în coș și pe pagina clubului (înlocuiește Joy).
   Recompensele și nivelurile vin din data-rewards / data-tiers (metafield-ul magazinului femieko_club.settings);
   REWARDS e doar rezerva. Textele coșului: română, greacă, engleză pentru celelalte limbi (data-lang).
   Picăturile se calculează din valoarea în lei; în altă monedă convertim cu cursul magazinului (Shopify.currency.rate).
   Linkul „Folosește în coș” din Contul meu deschide coșul cu ?fe_club_redeem=<cost> și preselectează recompensa.
   Previzualizare doar pe temele nepublicate: ?fe_club_demo=420 simulează un cont cu 420 de picături (și tot atâtea
   strânse în total), ?fe_club_demo=off o oprește. */
(() => {
  if (window.FeClub) return;

  const REWARDS = [
    { cost: 150, type: 'percent', value: 10 },
    { cost: 250, type: 'percent', value: 15 },
    { cost: 350, type: 'shipping', value: 100 },
  ];
  // Doar pentru previzualizare (?fe_club_demo=), cât timp nivelurile sunt oprite din setări.
  const DEMO_TIERS = [
    { name: 'Love Drop', points: 1000, percent: 10 },
    { name: 'Love Wave', points: 2000, percent: 15 },
    { name: 'Love Ocean', points: 3000, percent: 20 },
  ];
  const ATTR = '_fe_club_redeem';
  const PARAM = 'fe_club_redeem';
  let paramHandled = false;
  const KEY = 'fe_club_demo';

  const TEXT = {
    ro: {
      locale: 'ro-RO',
      title: 'Picături Love',
      balance: (n) => `Ai ${n} Picături Love`,
      earn: (n) => `Primești <strong>${n} Picături Love</strong> pentru această comandă.`,
      login: (a) => `<a href="${a}">Conectează-te</a> ca să-ți folosești Picăturile Love la această comandă.`,
      percent: (p) => `${p}% reducere`,
      shipping: 'Transport gratuit',
      missing: (n) => `îți mai trebuie ${n}`,
      cost: (n) => `${n} picături`,
      covered: (p) => `ai deja ${p}% prin nivel`,
      tier: (name, p) => `Nivel ${name}: ${p}% reducere, aplicată automat la finalizarea comenzii.`,
      group: 'Folosește Picături Love',
      applied: (r) => `${r} se aplică la finalizarea comenzii.`,
      undo: 'Renunță',
      choose: 'Alege o recompensă; o aplicăm automat la finalizarea comenzii.',
      demo: 'previzualizare',
    },
    el: {
      locale: 'el-GR',
      title: 'Σταγόνες Love',
      balance: (n) => `Έχεις ${n} Σταγόνες Love`,
      earn: (n) => `Κερδίζεις <strong>${n} Σταγόνες Love</strong> με αυτή την παραγγελία.`,
      login: (a) => `<a href="${a}">Συνδέσου</a> για να χρησιμοποιήσεις τις Σταγόνες Love σε αυτή την παραγγελία.`,
      percent: (p) => `έκπτωση ${p}%`,
      shipping: 'Δωρεάν αποστολή',
      missing: (n) => `χρειάζεσαι ακόμη ${n}`,
      cost: (n) => `${n} σταγόνες`,
      covered: (p) => `έχεις ήδη ${p}% με το επίπεδό σου`,
      tier: (name, p) => `Επίπεδο ${name}: έκπτωση ${p}%, εφαρμόζεται αυτόματα στο ταμείο.`,
      group: 'Χρήση Σταγόνων Love',
      applied: (r) => `Η ανταμοιβή «${r}» εφαρμόζεται στο ταμείο.`,
      undo: 'Ακύρωση',
      choose: 'Διάλεξε μια ανταμοιβή· την εφαρμόζουμε αυτόματα στο ταμείο.',
      demo: 'προεπισκόπηση',
    },
    da: {
      locale: 'da-DK',
      title: 'Love Drops',
      balance: (n) => `Du har ${n} Love Drops`,
      earn: (n) => `Du optjener <strong>${n} Love Drops</strong> med denne ordre.`,
      login: (a) => `<a href="${a}">Log ind</a> for at bruge dine Love Drops på denne ordre.`,
      percent: (p) => `${p}% rabat`,
      shipping: 'Gratis fragt',
      missing: (n) => `du mangler ${n}`,
      cost: (n) => `${n} drops`,
      covered: (p) => `du får allerede ${p}% med dit niveau`,
      tier: (name, p) => `Niveau ${name}: ${p}% rabat, trækkes automatisk fra ved betalingen.`,
      group: 'Brug Love Drops',
      applied: (r) => `${r} trækkes fra ved betalingen.`,
      undo: 'Fjern',
      choose: 'Vælg en belønning; vi trækker den automatisk fra ved betalingen.',
      demo: 'forhåndsvisning',
    },
    sv: {
      locale: 'sv-SE',
      title: 'Love Drops',
      balance: (n) => `Du har ${n} Love Drops`,
      earn: (n) => `Du tjänar <strong>${n} Love Drops</strong> med den här beställningen.`,
      login: (a) => `<a href="${a}">Logga in</a> för att använda dina Love Drops på den här beställningen.`,
      percent: (p) => `${p}% rabatt`,
      shipping: 'Fri frakt',
      missing: (n) => `${n} kvar`,
      cost: (n) => `${n} drops`,
      covered: (p) => `du får redan ${p}% med din nivå`,
      tier: (name, p) => `Nivå ${name}: ${p}% rabatt, dras av automatiskt i kassan.`,
      group: 'Använd Love Drops',
      applied: (r) => `${r} dras av i kassan.`,
      undo: 'Ta bort',
      choose: 'Välj en belöning; vi drar av den automatiskt i kassan.',
      demo: 'förhandsvisning',
    },
    de: {
      locale: 'de-DE',
      title: 'Love Drops',
      balance: (n) => `Du hast ${n} Love Drops`,
      earn: (n) => `Du sammelst <strong>${n} Love Drops</strong> mit dieser Bestellung.`,
      login: (a) => `<a href="${a}">Melde dich an</a>, um deine Love Drops bei dieser Bestellung einzulösen.`,
      percent: (p) => `${p}% Rabatt`,
      shipping: 'Kostenloser Versand',
      missing: (n) => `noch ${n} nötig`,
      cost: (n) => `${n} Drops`,
      covered: (p) => `mit deinem Level bekommst du bereits ${p}%`,
      tier: (name, p) => `Level ${name}: ${p}% Rabatt, wird an der Kasse automatisch abgezogen.`,
      group: 'Love Drops einlösen',
      applied: (r) => `${r} wird an der Kasse abgezogen.`,
      undo: 'Entfernen',
      choose: 'Wähle eine Prämie; wir ziehen sie an der Kasse automatisch ab.',
      demo: 'Vorschau',
    },
    en: {
      locale: 'en-GB',
      title: 'Love Drops',
      balance: (n) => `You have ${n} Love Drops`,
      earn: (n) => `You earn <strong>${n} Love Drops</strong> with this order.`,
      login: (a) => `<a href="${a}">Sign in</a> to use your Love Drops on this order.`,
      percent: (p) => `${p}% off`,
      shipping: 'Free shipping',
      missing: (n) => `${n} more needed`,
      cost: (n) => `${n} drops`,
      covered: (p) => `you already get ${p}% with your level`,
      tier: (name, p) => `${name} level: ${p}% off, applied automatically at checkout.`,
      group: 'Use Love Drops',
      applied: (r) => `${r} is applied at checkout.`,
      undo: 'Remove',
      choose: 'Choose a reward; we apply it automatically at checkout.',
      demo: 'preview',
    },
  };
  const textFor = (lang) => TEXT[String(lang || 'ro').slice(0, 2)] || TEXT.en;

  const demoPoints = () => {
    try {
      const q = new URLSearchParams(location.search).get(KEY);
      if (q === 'off') sessionStorage.removeItem(KEY);
      else if (q !== null && /^\d+$/.test(q)) sessionStorage.setItem(KEY, q);
      const v = sessionStorage.getItem(KEY);
      return v === null ? null : Number(v);
    } catch (e) {
      return null;
    }
  };

  const fmt = (n, locale = 'ro-RO') => Number(n).toLocaleString(locale);
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  const rewardLabel = (r, t = TEXT.ro) => (r.type === 'shipping' ? t.shipping : t.percent(r.value));

  const parseList = (raw) => {
    try {
      const list = JSON.parse(raw || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  };

  // Recompensele cu numele generat din tip și procent, în limba coșului.
  const rewardsOf = (el, t = textFor(el.dataset.lang)) => {
    const list = parseList(el.dataset.rewards)
      .map((r) => ({ cost: Number(r.cost), type: r.type === 'shipping' ? 'shipping' : 'percent', value: Number(r.value) }))
      .filter((r) => r.cost > 0 && (r.type === 'shipping' || r.value > 0))
      .sort((a, b) => a.cost - b.cost);
    return (list.length ? list : REWARDS).map((r) => ({ ...r, label: rewardLabel(r, t) }));
  };

  // Nivelul după picăturile strânse în total (aceeași regulă ca funcția de reducere din checkout).
  const tierOf = (el, lifetime, demo = false) =>
    (parseList(el.dataset.tiers).length || !demo ? parseList(el.dataset.tiers) : DEMO_TIERS)
      .map((x) => ({ name: String(x.name || ''), points: Number(x.points), percent: Number(x.percent) }))
      .filter((x) => x.points > 0 && x.percent > 0 && lifetime >= x.points)
      .sort((a, b) => b.points - a.points)[0] || null;

  window.FeClub = { REWARDS, demoPoints, fmt, rewardsOf };

  class FeClubCart extends HTMLElement {
    connectedCallback() {
      this.render();
      this.applyParam();
    }

    get t() {
      return textFor(this.dataset.lang);
    }

    // ?fe_club_redeem=<cost> din Contul meu: alege recompensa o singură dată, apoi curăță adresa.
    applyParam() {
      if (paramHandled) return;
      let cost;
      try {
        const url = new URL(location.href);
        cost = url.searchParams.get(PARAM);
        if (cost === null) return;
        paramHandled = true;
        url.searchParams.delete(PARAM);
        history.replaceState(history.state, '', url.pathname + url.search + url.hash);
      } catch (e) {
        return;
      }
      const s = this.state;
      const reward = rewardsOf(this).find((r) => String(r.cost) === cost);
      if (s.logged && reward && reward.cost <= s.points && !this.covered(reward, s) && reward.cost !== s.selected) this.choose(String(reward.cost));
    }

    // Picăturile pentru comandă: calculul din Liquid (lei) sau, în altă monedă, conversia cu cursul magazinului.
    earnPoints() {
      const d = this.dataset;
      if (d.earn !== '') return Number(d.earn) || 0;
      const rate = Number(window.Shopify && Shopify.currency && Shopify.currency.rate) || 0;
      if (!(rate > 0)) return null;
      const std = (Number(d.std) || 0) / rate;
      const sub = (Number(d.sub) || 0) / rate;
      return Math.floor(std / (Number(d.rate) || 500)) + Math.floor(sub / (Number(d.rateSub) || Number(d.rate) || 500));
    }

    get state() {
      const d = this.dataset;
      let logged = d.logged === 'true';
      let points = Number(d.points) || 0;
      let lifetime = Number(d.lifetime) || 0;
      const demo = d.demo === 'true' ? demoPoints() : null;
      if (demo !== null) {
        logged = true;
        points = demo;
        lifetime = Math.max(lifetime, demo);
      }
      return { logged, points, tier: tierOf(this, lifetime, demo !== null), demo: demo !== null, earn: this.earnPoints(), selected: Number(d.selected) || 0 };
    }

    // O recompensă % mai mică sau egală cu reducerea de nivel nu aduce nimic în plus: checkout-ul aplică nivelul.
    covered(r, s) {
      return Boolean(s.tier) && r.type === 'percent' && r.value <= s.tier.percent;
    }

    render() {
      const t = this.t;
      const n = (v) => fmt(v, t.locale);
      const s = this.state;
      const earn = s.earn > 0 ? `<p class="fe-club-cart__earn">${t.earn(n(s.earn))}</p>` : '';

      if (!s.logged) {
        this.innerHTML = `
          <div class="fe-club-cart__head"><span class="fe-club-cart__drop" aria-hidden="true"></span><span class="fe-club-cart__title">${esc(t.title)}</span></div>
          ${earn}
          <p class="fe-club-cart__login">${t.login(esc(this.dataset.login))}</p>`;
        return;
      }

      const rewards = rewardsOf(this, t);
      const selected = rewards.find((r) => r.cost === s.selected && r.cost <= s.points && !this.covered(r, s));
      const options = rewards.map((r) => {
        const missing = r.cost - s.points;
        const covered = this.covered(r, s);
        const on = selected && selected.cost === r.cost;
        const note = covered ? t.covered(s.tier.percent) : missing > 0 ? t.missing(n(missing)) : t.cost(n(r.cost));
        return `<button type="button" class="fe-club-cart__opt${on ? ' is-on' : ''}" data-cost="${r.cost}" ${missing > 0 || covered ? 'disabled' : ''} aria-pressed="${on}">
            <span class="fe-club-cart__opt-label">${esc(r.label)}</span>
            <span class="fe-club-cart__opt-cost">${esc(note)}</span>
          </button>`;
      }).join('');

      this.innerHTML = `
        <div class="fe-club-cart__head">
          <span class="fe-club-cart__drop" aria-hidden="true"></span>
          <span class="fe-club-cart__title">${esc(t.balance(n(s.points)))}</span>
          ${s.demo ? `<span class="fe-club-cart__demo">${esc(t.demo)}</span>` : ''}
        </div>
        ${s.tier ? `<p class="fe-club-cart__tier">${esc(t.tier(s.tier.name, s.tier.percent))}</p>` : ''}
        ${earn}
        <div class="fe-club-cart__opts" role="group" aria-label="${esc(t.group)}">${options}</div>
        ${
          selected
            ? `<p class="fe-club-cart__note">${esc(t.applied(selected.label))} <button type="button" class="fe-club-cart__undo">${esc(t.undo)}</button></p>`
            : `<p class="fe-club-cart__note">${esc(t.choose)}</p>`
        }`;

      this.querySelectorAll('.fe-club-cart__opt:not([disabled])').forEach((b) =>
        b.addEventListener('click', () => this.choose(b.classList.contains('is-on') ? '' : b.dataset.cost))
      );
      const undo = this.querySelector('.fe-club-cart__undo');
      if (undo) undo.addEventListener('click', () => this.choose(''));
    }

    async choose(cost) {
      this.classList.add('is-busy');
      try {
        const res = await fetch(`${root()}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { [ATTR]: cost } }),
        });
        if (!res.ok) throw new Error(res.status);
        this.dataset.selected = cost;
        this.render();
        if (this.closest('cart-drawer')) document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (e) {
        console.error('FemiEko Club', e);
      } finally {
        this.classList.remove('is-busy');
      }
    }
  }

  // Pagina FemiEko Club: copiere cod, apariție la derulare și, în previzualizare, starea de membru cu soldul simulat.
  class FeClubPage extends HTMLElement {
    connectedCallback() {
      this.applyDemo();
      this.bindCopy();
      this.reveal();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    applyDemo() {
      const demo = this.dataset.demo === 'true' ? demoPoints() : null;
      if (demo === null) return;
      this.classList.add('is-member', 'is-demo');
      this.querySelectorAll('[data-fe-club-points]').forEach((el) => (el.textContent = fmt(demo)));
      this.querySelectorAll('[data-fe-club-name]').forEach((el) => (el.textContent = ''));
      const next = rewardsOf(this).find((r) => r.cost > demo);
      this.querySelectorAll('[data-fe-club-next]').forEach((el) => {
        el.textContent = next ? `Încă ${fmt(next.cost - demo)} până la ${next.label.toLowerCase()}` : 'Toate recompensele sunt disponibile';
      });
      // Nivelul simulat: cel mai mare prag atins cu soldul de previzualizare.
      const tiers = [...this.querySelectorAll('[data-fe-club-tier]')];
      const reached = tiers.filter((el) => demo >= Number(el.dataset.feClubTier)).pop();
      tiers.forEach((el) => {
        el.classList.toggle('is-current', el === reached);
        const you = el.querySelector('.fe-club__tier-you');
        if (you) you.hidden = el !== reached;
      });
      this.querySelectorAll('[data-fe-club-reward]').forEach((el) => {
        const missing = Number(el.dataset.feClubReward) - demo;
        const st = el.querySelector('.fe-club__reward-state');
        el.classList.toggle('is-ready', missing <= 0);
        if (st) st.textContent = missing <= 0 ? 'Disponibil în coș' : `Îți mai trebuie ${fmt(missing)}`;
      });
    }

    bindCopy() {
      const btn = this.querySelector('[data-fe-club-copy]');
      const code = this.querySelector('[data-fe-club-code]');
      if (!btn || !code) return;
      const label = btn.textContent;
      btn.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(code.textContent.trim());
          btn.textContent = btn.dataset.copied || 'Cod copiat';
        } catch (e) {
          btn.textContent = btn.dataset.copyFail || 'Selectează codul și copiază-l';
        }
        setTimeout(() => (btn.textContent = label), 2200);
      });
    }

    reveal() {
      const items = this.querySelectorAll('[data-reveal]');
      if (!items.length || !('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.observer = new IntersectionObserver(
        (entries) =>
          entries.forEach((e) => {
            if (!e.isIntersecting) return;
            e.target.classList.add('is-in');
            this.observer.unobserve(e.target);
          }),
        { rootMargin: '0px 0px -8% 0px', threshold: 0.15 }
      );
      items.forEach((el) => this.observer.observe(el));
      this.classList.add('is-ready');
    }
  }

  customElements.define('fe-club-cart', FeClubCart);
  customElements.define('fe-club-page', FeClubPage);
})();
